import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigService } from 'src/app/services/config/config.service';
import { ConfigViewModelService } from 'src/app/services/configViewModel/config-view-model.service';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';
import { ColumnInfo, PreviewTableComponent } from '../../../preview-table/preview-table.component';
import {  FarmConverterRule, MapControlLegendType} from 'src/app/domainObjects/transformers/farmConverterTransform';
import { DataConnectorMapping } from 'src/app/domainObjects/dataConnectorMapping';
import { DataTransformerConfig } from 'src/app/domainObjects/dataTransformConfig';
import { ImportDataViewModel } from 'src/app/viewModels/importDataViewModel';
import { LogicOperatorType } from 'src/app/domainObjects/logicalOperatorType';
import { NavigationService } from 'src/app/services/navigation/navigation.service';
import { ColoredTextItem } from 'src/app/domainObjects/coloredTextItem';
import { ColumnFilterInfo } from 'src/app/views/previewTable/filterUI/column-filter/column-filter.component';
import { BaseTransformerUIComponent } from '../../../dataTransformConfig/transformers/base/base-transformer-ui/base-transformer-ui.component';
import { TransformPipelineService } from '../../../../services/transformPipeline/transform-pipeline.service';
import { ColumnFilter } from 'src/app/domainObjects/columnFilter';
import { DataDictionaryService } from '../../../../services/dataDictionary/data-dictionary.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { FormBuilder, FormControl, FormGroup, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SortInfo } from 'src/app/domainObjects/sortInfo';
import { SortBuilderComponent } from 'src/app/views/transform/sort-builder/sort-builder.component';
import { DataTransformConfigViewModel } from '../../../../viewModels/dataTransformConfigViewModel';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { TransformRuleViewModel } from 'src/app/viewModels/transformRuleViewModel';
import { DataFarmType, DataFarmTypeUtil } from 'src/app/domainObjects/dataFarmType';
import { UserDataService } from 'src/app/services/user-data-service';
import { RefineryPresenceService } from 'src/app/services/refinery-presence.service';
import { IncludeBuilderComponent } from '../../include-builder/include-builder.component';
import { IncludeInfo } from 'src/app/domainObjects/includeInfo';
import { LinkNodeViewModel, NodeViewModel } from 'src/app/domainObjects/nodeViewModel';
import { PreviewDataOptions } from 'src/app/domainObjects/previewDataOptions';
import { GetDataFarmPreviewRequest } from 'src/app/messaging/getDataFarmPreviewRequest';
import { FarmConverterTransformDetailViewModel, MapControlLegendTypeUtil } from './farmConverterTransformDetailViewModel';
import { FarmConverterRuleViewModel } from './farmConverterRuleViewModel';
import { ErrorDialogComponent } from '../../../error-dialog/error-dialog.component';
import { map,pick,isEqual } from 'lodash';
import { Observable } from 'rxjs';
import { ComponentCanDeactivate } from 'src/app/guards/pending-changes.guard';
import { TransformerViewModel } from 'src/app/views/transformer-list/transformer-list.component';
import { TransformType, TransformTypeUtil } from 'src/app/domainObjects/transformType';
import { ExportColumnInfo, ExportViewModel } from 'src/app/viewModels/exportViewModel';
import { DataDictionaryType } from 'src/app/domainObjects/dataDictionaryType';
import { NodeRunStatus } from 'src/app/domainObjects/nodeRunStatus';
import { UpdateNodesStatusRequest } from 'src/app/model/RunrefineryRequest';
import { ExportOutputDataDynamicComponent } from '../../export-output-data-dynamic/export-output-data-dynamic.component';
import { FarmType, ParameterSetting } from 'src/app/domainObjects/masterConfig';
import { OptionItem } from 'src/app/model/optionItem';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { map as rxmap,startWith } from 'rxjs/operators';
import { ColumnMapDefinitionModel } from 'src/app/model/columnMapDefinitionModel';
import { SelectFilterInfo } from 'src/app/views/shared/select-filter-option/select-filter-option.component';
import { SaveCurrntTransfrmcacheRequest } from 'src/app/messaging/saveCurrntTransfrmcacheRequest';

@Component({
    selector: 'app-farm-converter-transform-detail',
    templateUrl: './farm-converter-transform-detail.component.html',
    styleUrls: ['./farm-converter-transform-detail.component.css'],
    standalone: false
})
export class FarmConverterTransformDetailComponent extends BaseTransformerUIComponent<FarmConverterTransformDetailViewModel> 
implements OnInit,ComponentCanDeactivate{
  selectedIndex: number = 0;  
  dataSource: MatTableDataSource<FarmConverterRuleViewModel>;
  previewDataViewModel: ImportDataViewModel;
  isRuleSetEmpty = true;
  isRuleExecuting = false;
  MapControlLegendTypeUtil = MapControlLegendTypeUtil;
  MapControlLegendTypes = [
    MapControlLegendType.fcoptionone,
    MapControlLegendType.fcoptiontwo,
    MapControlLegendType.fcoptionthree,
    MapControlLegendType.fcoptionfour,
    MapControlLegendType.fcoptionfive
  ];
  MapControlLegendTypesOptional = [
    MapControlLegendType.fcoptionone,
    MapControlLegendType.fcoptiontwo,
    MapControlLegendType.fcoptionthree,
    // MapControlLegendType.fcoptionfour,
    MapControlLegendType.fcoptionfive
  ];
  displayedColumns: string[] = [
    'mapInclude',
    'mapFrom',
    'mapType',
    'mapTo',
    'mapShow'];

    displayedColumnsdef: string[] = [
      'mapFrom',
      'mapType',
      'mapTo',
      'mapShow'];
  isRulesMaximized = false;

  sortCtrl = new UntypedFormControl('');
  sortCtrlIF = new UntypedFormControl('');

  form: FormGroup;
  formparam: FormGroup;
  configs: FarmConverterRule[];
  compulsorydiff: FarmConverterRule[];
  @ViewChild(ExportOutputDataDynamicComponent) exportComponent: ExportOutputDataDynamicComponent;
  separatorControl:FormControl;
  separatorOptions: Observable<{ value: string; text: string }[]>;
  separators = [{ value: '|', text: '| (pipe)' },
    { value: ':', text: ': (colon)' },
    { value: ';', text: '; (semicolon) ' },
    { value: ',', text: ', (comma)' },
    { value: ' ', text: '" " (space)' },
    { value: '/', text: '/ Forward Slash' },
    { value: '\\', text: '\\ Backward Slash' }
  ];

  constructor(
    activeRoute: ActivatedRoute,
    errorService: ErrorReportingService,
    matDialog: MatDialog,
    snackBar: MatSnackBar,
    router: Router,
    configViewModelService: ConfigViewModelService,
    configService: ConfigService,
    navService: NavigationService,
    transformPipelineService: TransformPipelineService,
    userData: UserDataService,
    dataDictService: DataDictionaryService,
    refineryPresence: RefineryPresenceService,
    private cdRef: ChangeDetectorRef,private fb: FormBuilder ) {

      super(activeRoute, errorService, matDialog, snackBar, router, configViewModelService, configService, navService, transformPipelineService, userData,dataDictService, refineryPresence);
      this.transformType = TransformType.farmConverter;
  }
  public farmtypeid: number = 0;
  DataFarmType=DataFarmType;
  //other parameters
  resetRows: ParameterSetting=new ParameterSetting();
  sortInfoa: ParameterSetting=new ParameterSetting();
  sortInfoOut: ParameterSetting=new ParameterSetting();
  //advanced settings parameters
  timestampFielda: ParameterSetting=new ParameterSetting();
  groupBy: ParameterSetting=new ParameterSetting();
  groupByL2: ParameterSetting=new ParameterSetting();
  defSourceFielda: ParameterSetting=new ParameterSetting();
  entityList: ParameterSetting=new ParameterSetting();
  userField: ParameterSetting=new ParameterSetting();
  bufferRows: ParameterSetting=new ParameterSetting();
  threads: ParameterSetting=new ParameterSetting();
  listSeparator: ParameterSetting=new ParameterSetting();
  defTimeout: ParameterSetting=new ParameterSetting();
  sequenceL2: ParameterSetting=new ParameterSetting();

  defaultTargetColumn = 'None';
  disabledColumns:any;
  options: string[] =[];
  sourceColumnsOptions: string[] =[];
  dateTimeSourceColumnsOptions: string[] =[];
  transformType:TransformType;
  ngOnInit(): void {
    super.ngOnInit();
    this.userData.setInputTabClicked(false);
    var node=this.userData.getSelectedNodeDetails();
    this.farmtypeid=node.farmtypeid;
    //validation
    this.isParameterFormValid = true;
    this.formparam = this.fb.group({
      
    });
    this.registerFormGroup(this.formparam);
    this.form = this.fb.group({
      timestampFieldaField: [null, []],
      groupByField: [null, []],
      groupByL2Field: [null, []],
      defSourceFieldaField: [null, []],
      entityListField: [null, []],
      userFieldField: [null, []],
      separatorControl: [null, []],
    });
    this.registerFormGroup(this.form);
  }

  protected override async onRouteActivated(_routeParams: any): Promise<void> {
    this.viewModel = new FarmConverterTransformDetailViewModel(
        this.dataDictService,
        this.configService,
        this.dataTransformConfigViewModel,
        this.transformViewModel);
      //set farm type as state transformViewModel has value 0 bug in parent or prev page
      this.viewModel.farmType=this.userData.getSelectedNodeDetails().farmtypeid;
      //Fetch targetColumns data dict by node farmtypeid  
      this.configureTargetColumnsFarmtypeid(this.userData.getSelectedNodeDetails().farmtypeid);
      //deep copy of viewmodel for canDeactivate
      this.snapshotPreState();
      
      this.dataSource = new MatTableDataSource<FarmConverterRuleViewModel>(this.viewModel.mapTable);
      this.isRuleSetEmpty = this.viewModel.mapTable.length === 0;

      var linkviewlist=this.userData.getSelectedNodeDetails();
      
      if (this.previewTable) {
        this.previewTable.clear();
      }

      if (this.outputDataFarmPreviewTable) {
        this.outputDataFarmPreviewTable.clear();
      }
      
      await this.setTransformerDetails(this.transformType);
      await this.downloadInputDataAsync();
      
      // await this.settingMapTable();
    
    this.CalculateFieldsMapped();
    await this.setDefaultValues(this.transformType);
    await this.removeInvalidValues();
      
      //Refresh Default Field controls as input farm fields may have changed
      //advanced settings parameters
      const foundtimestampField = this.viewModel.sourceColumns.find(sc => sc.value == this.viewModel.timestampField);
      if(!foundtimestampField){
        this.viewModel.timestampField="";
        for(let pr of this.timestampFielda.default.split(";")){
          const foundColumn = this.viewModel.sourceColumns.find(sc => sc.value == pr);
          if(foundColumn){
            this.viewModel.timestampField=foundColumn.value;
            break;
          }
        }
      }
      
      const foundgroupBy = this.viewModel.sourceColumns.find(sc => sc.value == this.viewModel.groupBy);
      if(!foundgroupBy){
        this.viewModel.groupBy="";
        for(let pr of this.groupBy.default.split(";")){
          const foundColumn = this.viewModel.sourceColumns.find(sc => sc.value == pr);
          if(foundColumn){
            this.viewModel.groupBy=foundColumn.value;
            break;
          }
        }
      }
      
    const foundgroupByL2 = this.viewModel.sourceColumns.find(sc => sc.value == this.viewModel.groupByL2);
    if(!foundgroupByL2){
      this.viewModel.groupByL2="";
      for(let pr of this.groupByL2.default.split(";")){
        const foundColumn = this.viewModel.sourceColumns.find(sc => sc.value == pr);
        if(foundColumn){
          this.viewModel.groupByL2=foundColumn.value;
          break;
        }
      }
    }

    const founddefSourceField = this.viewModel.sourceColumns.find(sc => sc.value == this.viewModel.defSourceField);
    if(!founddefSourceField){
      this.viewModel.defSourceField="";
      for(let pr of this.defSourceFielda.default.split(";")){
        const foundColumn = this.viewModel.sourceColumns.find(sc => sc.value == pr);
        if(foundColumn){
          this.viewModel.defSourceField=foundColumn.value;
          break;
        }
      }
    }

    const founduserField = this.viewModel.sourceColumns.find(sc => sc.value == this.viewModel.userField);
    if(!founduserField){
      this.viewModel.userField="";
      for(let pr of this.userField.default.split(";")){
        const foundColumn = this.viewModel.sourceColumns.find(sc => sc.value == pr);
        if(foundColumn){
          this.viewModel.userField=foundColumn.value;
          break;
        }
      }
    }
    console.log("this.viewModel.sortInfoFirst :",this.viewModel.sortInfo);
    //other parameters Filter invalid sort fields
    this.viewModel.sortInfo = this.viewModel.sortInfo.filter(sort => {
      return this.viewModel.sourceColumns.some(sc => sc.value === sort.sortField);
    });

    var node=this.userData.getSelectedNodeDetails();
    if(node.farmtypeid==DataFarmType.task){
      this.mapfromtext="Subtask Fields";
      this.maptotext="Task Fields";
      this.farmname="Task";
      this.image="Farm Converter Icon Orange.png";
      this.subfarmename=" (Subtask > Task)";
      this.farmcolor="#98FB00";
      //
      this.viewModel.orderField ="taskOrder";
      this.viewModel.isOpenField ="isOpenTask";
      this.viewModel.isCloseField ="isCloseTask";
      this.viewModel.entityStart ="taskStart";
      this.viewModel.entityEnd ="taskEnd";
      this.viewModel.subRows ="subtaskRows";
      this.viewModel.addFields=["taskStart","taskEnd","subtaskRows","subtaskList"];
      this.viewModel.entryListColumns=["subtaskList","taskDetail1","taskDetail2","taskDetail3","taskDetail4","taskDetail5","taskDetail6"];
    }
    else if(node.farmtypeid==DataFarmType.activity){
      this.mapfromtext="Task Fields";
      this.maptotext="Activity Fields";
      this.farmname="Activity";
      this.image="Farm Converter Icon Light Blue.png";
      this.subfarmename=" (Task > Activity)";
      this.farmcolor="#00B050";
      //
      this.viewModel.orderField ="activityOrder";
      this.viewModel.isOpenField ="isOpenActivity";
      this.viewModel.isCloseField ="isCloseActivity";
      this.viewModel.entityStart ="activityStart";
      this.viewModel.entityEnd ="activityEnd";
      this.viewModel.subRows ="taskRows";
      this.viewModel.addFields=["activityStart","activityEnd","taskRows","taskList"];
      this.viewModel.entryListColumns=["taskList","activityDetail1","activityDetail2","activityDetail3","activityDetail4","activityDetail5","activityDetail6"];
    }
    this.onToggleSequenceL2();
    if(!this.viewModel.entityList){
      for(let pr of this.entityList.default.split(";")){
        const foundColumn = this.viewModel.entryListColumns.find(sc => sc == pr);
        if(foundColumn){
          this.viewModel.entityList=foundColumn;
          break;
        }
      }
    }
    this.separatorControl = this.form.get('separatorControl') as FormControl;
      this.separatorOptions = this.separatorControl.valueChanges.pipe(
      startWith(''),
      rxmap((value) => this._filterSeparator(value || ''))
      );

    this.filterSourceColumns();
    await this.settingMapTable();
    //remove row from targetColumns
    this.options =[...this.viewModel.targetColumns.filter(tc => tc !== 'row').map(col => col).sort((a, b) => a.localeCompare(b))];
    this.disabledColumns = this.viewModel.mapTable.map(item => item.mapTo);
  }

  private _filterSeparator(value: string): { value: string; text: string }[] {
    const filterValue = value.toLowerCase();
    return this.separators.filter((separator) =>
      separator.text.toLowerCase().includes(filterValue)
    );
  }
  strSourceColumns:OptionItem[]=[];
  dateTimeSourceColumns:OptionItem[]=[];
  userSourceColumns:OptionItem[]=[];
  userKeywords = ["userId", "userId2", "userId3", "associateId", "userName"];
  dateTimeKeywords = ["subtaskTimestamp", "subtaskDateTime1", "subtaskDateTime2", "taskEnd", "taskStart", "taskDateTime1", "taskDateTime2"];
  filterSourceColumns(): void {
    this.inputDataFarmPreviewTable.displayedColumnInfos.filter(col=>this.getDataType(col.pydataType)=="string").forEach(map=>{
      this.strSourceColumns.push(new OptionItem(map.name, map.name));
    });
    this.inputDataFarmPreviewTable.displayedColumnInfos.filter(col=>this.getDataType(col.pydataType)=="datetime").forEach(map=>{
      this.dateTimeSourceColumns.push(new OptionItem(map.name, map.name));
      this.dateTimeSourceColumnsOptions=this.dateTimeSourceColumns.map(item => item.text);
    });
    this.inputDataFarmPreviewTable.displayedColumnInfos.filter(col=>this.userKeywords.some(k => col.name.includes(k))).forEach(map=>{
      this.userSourceColumns.push(new OptionItem(map.name, map.name));
      this.sourceColumnsOptions=this.userSourceColumns.map(item => item.text);
    });
  }
  mapfromtext:string="";
  maptotext:string="";
  farmname:string="";
  image:string="";
  subfarmename:string="";
  farmcolor:string="";
  ngAfterViewInit(): void {
    
  }
  isRequiredFieldMissing:boolean=false;
  getstylemapFrom(mapFromRule = ''){
  if(this.compulsorydiff){
      if(mapFromRule != '' && mapFromRule != 'Transfomer Created'){
        var isMapFromPresent = this.compulsorydiff.some(function(obj) {
          return obj.mapFrom === mapFromRule;
        });
        if(isMapFromPresent){
          this.isRequiredFieldMissing=isMapFromPresent;
          return {'--td-color':'#FF0000'};
        }
      }
    }
    if(mapFromRule == 'Transfomer Created'){
      return {'--td-color':'#797979'};
    }
    var farmtypes=this.userData.getMasterFarmtypes();
  
    if(this.farmtypeid==2){
      var farmtype=farmtypes.find(x=>x.id==1);//SubTask
      return {'--td-color':farmtype.color};
    }
    else if(this.farmtypeid==3){
      var farmtype=farmtypes.find(x=>x.id==2);//Task
      return {'--td-color':farmtype.color};
    }
    return {'':''};
  }
  getstylemapTo(){
    var node=this.userData.getSelectedNodeDetails();
    return {'--td-color':node.nodeColor};
    // if(this.farmtypeid==2){
    //   return {'color':node.nodeColor};
    // }
    // else if(this.farmtypeid==3){
    //   return {'color':node.nodeColor};
    // }
    // return {'':''};
  }
  minrowcount:number=10;
  maxrowcount:number=100;
  isScrollBottom:boolean=true;
   async addNewRule(): Promise<void> {
    
  }
  onTransformTextChanged(){
    this.viewModel.transformViewModel.name=this.viewModel.transform.name;
    var currenttransform=this.dataTransformConfigViewModel.transforms.find(x=>x.guid==this.viewModel.transform.guid);
    currenttransform.name=this.viewModel.transform.name;
    currenttransform.transform.name=this.viewModel.transform.name;
    var vartransform=this.transformslists.find(x=>x.guid==this.viewModel.transform.guid);
    vartransform.name=this.viewModel.transform.name;
  }
  dropTable(event: CdkDragDrop<MatTableDataSource<TransformRuleViewModel>>): void {
    const prevIndex = event.previousIndex;
    const currentItem: FarmConverterRuleViewModel = event.item.data;
    //currentItem.index = prevIndex;
    moveItemInArray(this.viewModel.mapTable, prevIndex, event.currentIndex);
    //this.viewModel.reindexRules();
    this.dataSource.data = this.viewModel.mapTable;
  }
  
  onRunChanged(event: MatSlideToggleChange): void {
    //this.viewModel.mapTable.forEach( r => r.run = event.checked);
  }

  toggleRulesHeight(): void {
    this.isRulesMaximized = !this.isRulesMaximized;
  }

  removeSortInfo(sortInfo: SortInfo): void {
    const index = this.viewModel.sortInfo?.indexOf(sortInfo);

    if (index >= 0) {
      this.viewModel.sortInfo?.splice(index, 1);
    }
  }
  removeSortInfoIF(sortInfo: SortInfo): void {
    const index = this.viewModel.sortInfoOut?.indexOf(sortInfo);

    if (index >= 0) {
      this.viewModel.sortInfoOut?.splice(index, 1);
    }
  }
  showSortBuilder(): void {
    const dialog = this.matDialog.open(SortBuilderComponent, {
      data: {
        fields: this.viewModel.sourceColumns.map(c => c.text),
        sortItems: [...this.viewModel.sortInfo ?? []] // make copy of array so it doesn't edit actual list
      }
    });

    dialog.afterClosed().subscribe(result => {
      if (!result) {
        return;
      }

      const items = result.sortItems;
      this.viewModel.sortInfo = items;
      //this.viewModel.sortInfoDisplay = this.viewModel.sortInfo.map(i => `${i.sortField} (${i.sortAscending ? 'asc' : 'desc'})}`).join(',');
      this.sortCtrl.setValue(null);
    });
  }
  showSortBuilderIF(): void {
    const dialog = this.matDialog.open(SortBuilderComponent, {
      data: {
        fields: this.viewModel.sortInfoOutColumns.map(c => c.text),
        sortItems: [...this.viewModel.sortInfoOut ?? []] // make copy of array so it doesn't edit actual list
      }
    });

    dialog.afterClosed().subscribe(result => {
      if (!result) {
        return;
      }

      const items = result.sortItems;
      this.viewModel.sortInfoOut = items;
      //this.viewModel.sortInfoDisplay = this.viewModel.sortInfo.map(i => `${i.sortField} (${i.sortAscending ? 'asc' : 'desc'})}`).join(',');
      this.sortCtrlIF.setValue(null);
    });
  }

  getClassForRow(sender: PreviewTableComponent, row: any, colInfo: ColumnInfo, colInfos: ColumnInfo[]): string {
    
    try {
      if (sender === this.previewTable) {
        if (this.viewModel.sourceColumns && this.viewModel.sourceColumns.find(f => f.text === colInfo.name) === undefined) {
          return 'meta-data-column-color';
        }
        
        const missCol = colInfos.filter( col => {
          return col.name === 'ruleMiss';
        });

        if (missCol.length === 1) {
          if (row[missCol[0].index] === true) {
            return 'missedRuleRow';
          }
        }
      }else if (sender === this.summaryDataFarmPreviewTableResult) {
        if(colInfo.name.startsWith("smry_count")){
          if(this.colorSummaryCount!=""){
            this.colorSummaryCount="";
            return 'meta-data-column-color';
          }
        }else{
          if (this.viewModel.sourceColumns && this.viewModel.sourceColumns.find(f => f.text === colInfo.name) === undefined) {
            this.colorSummaryCount='meta-data-column-color';
            return 'meta-data-column-color';
          }
        }
        
        const missCol = colInfos.filter( col => {
          return col.name === 'ruleMiss';
        });

        if (missCol.length === 1) {
          if (row[missCol[0].index] === true) {
            return 'missedRuleRow';
          }
        }
      }
    } catch (err) {
      //console.log(err);
    }

    return null;
  }

  showContainsEditorDialog(
    existingItems: ColoredTextItem[],
    onClosed: (items: ColoredTextItem[]) => any ): void {

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {items: existingItems, textTypeName: 'Contains', title: 'Multiple contains Text Editor'};
    dialogConfig.width = '600px';
  }

  runValidation(): void {
    if (this.isRequiredFieldMissing) {

      this.displayError('Cannot run the converter, please correct errors (red font) below.','Validation Error','');
      return;
    }
    else{
      this.runTransform()
    
    }
  

  }

  saveConfig(): void {
     //console.log("this.compulsorydiff :",this.compulsorydiff);
    // if (this.compulsorydiff.length > 0) {


    //   this.displayError('Cannot save the converter, please correct errors (red font) below.','Validation Error','');
    //   return;
    // }

    //console.log(this.dataTransformConfigViewModel);
    if (!this.validate()) {
      return;
    }
    
    if (this.dataTransformConfigViewModel.dataTransformerConfig?.id || this.dataTransformConfigViewModel.dataTransformerConfig?.guid) {
      //console.log('updating...');
      this.saveConfigImpl(this.dataTransformConfigViewModel.dataTransformerConfig.name);
    } else {
      //console.log('saving...');
      this.showSaveConfigDialog(async (configName: string) => {
        this.saveConfigImpl(configName);
      });
    }
  }

  async saveConfigImpl(configName: string): Promise<void> {
    const busyIndicator = this.showBusyDialog('Please wait...');
    try {
      let config = this.dataTransformConfigViewModel.dataTransformerConfig ?? new DataTransformerConfig();

      config.name = configName;
      config.organizationId = 1;
      config.dataSourceType = this.dataTransformConfigViewModel.dataSourceType;
      config.selectedIngestFarmGuid = this.dataTransformConfigViewModel.selectedIngestFarmGuid;
      
      // Save the Data Connectors
      config.dataConnectorMappings = this.dataTransformConfigViewModel.ingestConfigs
      .map ( ingestConfig =>
        new DataConnectorMapping(
          ingestConfig.id,
          ingestConfig.name,
          ingestConfig.targetDataFarm,
          ingestConfig.dataConnector.toDataConnector(),
          ingestConfig.columnMap
            .map(i => i.toColumnMapDefinition()),
          ingestConfig.guid,
          ingestConfig.masterColumnMapGuid)
      );

      //console.log('saving config...');
      //console.log(this.dataTransformConfigViewModel);

      // Save Transforms
      config.transforms = this.dataTransformConfigViewModel.transforms.map(t => t.transform);

      // Save the transform
      //const transform = config.transforms.find(t => t.id === this.viewModel.transform?.id) ?? this.viewModel.transformViewModel.transform;
      const transform = this.viewModel.transformViewModel.transform;

      transform.transformConfig = this.viewModel.toTransformConfig();
      transform.transformConfig.mapTable=transform.transformConfig.mapTable.filter(map=>map.mapFrom && map.mapTo);
      // transform.dataFarmName = this.viewModel.dataFarm.name;
      // transform.dataFarmType = this.viewModel.dataFarm.dataFarmType;

      // TODO: Maintain list of transforms for this config
      const existingTransform = config.transforms.find(t => t.guid === transform.guid);
      if (existingTransform) {
        config.transforms.splice(config.transforms.indexOf(existingTransform), 1);
      }
      config.transforms.push(transform);
      
      // Save the ingest transforms
      //console.log(JSON.stringify(config));

      config = await this.configService.upsertConfig(config);
      //console.log('received new data transform config from server: ' + JSON.stringify(config));
      this.userData.setSelectedConfigJson(config);
      this.configViewModelService.setDataTransformConfigViewModel(new DataTransformConfigViewModel(config));
      this.userData.setSelectedTransform(this.dataTransformConfigViewModel.transforms.find(x=>x.guid=== this.userData.getSelectedTransform().guid));
      //update preViewModel
      this.snapshotPreState();

      // SAve the current node status to Not RunConfigRequest.
      const selectedNode = this.userData.getSelectedNodeDetails();
      //const RefineryConfigJson = await this.configService.getRefineryConfigByGuidAsync(selectedNode.refineryConfigGuid);
      // //console.log('Refinery json in save = ', RefineryConfigJson) ;
      //RefineryConfigJson.nodes.filter(newNode => newNode.id == selectedNode.id)[0].data.nodeStatus = NodeRunStatus.NotRun
      //let RefineryJson = await this.configService.UpsertRefineryConfig(RefineryConfigJson);
      
      // var UpdateNodesStatus: UpdateNodesStatusRequest = new UpdateNodesStatusRequest(selectedNode.refineryConfigGuid, selectedNode.id, NodeRunStatus.PipelineModified )
      // let updateStatusreturn = await this.configService.updateUpcomingNodesStatus(UpdateNodesStatus);
      
      //Invoke the save current transformer cache api
      //  const activeTransformGuid = this.userData.getSelectedTransform().guid
      //  var saveCurrentTransformerCacheRequest: SaveCurrntTransfrmcacheRequest = new SaveCurrntTransfrmcacheRequest(selectedNode.id, selectedNode.refineryConfigGuid, this.dataTransformConfigViewModel.selectedIngestFarmGuid, activeTransformGuid);
      //  let saveCurrentTransformerCacheResponse = await this.configService.saveCurrentTransformerCache(saveCurrentTransformerCacheRequest);
      // this.cdRef.detectChanges();
      //Invoke the save current transformer cache api
       const activeTransformGuid = this.userData.getSelectedTransform().guid
       const userId = this.userData.getUserId()
       const orgId = this.userData.getOrgId()
       var saveCurrentTransformerCacheRequest: SaveCurrntTransfrmcacheRequest = new SaveCurrntTransfrmcacheRequest(userId, orgId, selectedNode.id, selectedNode.refineryConfigGuid, this.dataTransformConfigViewModel.selectedIngestFarmGuid, activeTransformGuid);
       await this.configService.saveCurrentTransformerCache(saveCurrentTransformerCacheRequest);
       await this.configService.getRefineryConfigByGuidAsync(this.userData.getRefineryId());
       this.getCacheStatus();
       // this.cdRef.detectChanges();

      this.snackBar.open(`Successfully saved transform pipeline '${this.userData.getSelectedTransform().name}'`, 'Dismiss', {
        duration: 5000
      });
    } catch (err) {
      this.displayError(`Failed to save '${this.userData.getSelectedTransform().name}'`, 'Error', err);
    } finally {
      busyIndicator.close();
    }
  }
  
  onSetDefaultRule(defaultfield:string){
    // if(defaultfield=="sourceColumn"){
    //   this.viewModel.rules.forEach(rule=>{
    //     rule.sourceColumn=this.viewModel.parameters.sourceColumn;
    //   })
    // }
    // else if(defaultfield=="targetColumn"){
    //   this.viewModel.rules.forEach(rule=>{
    //     rule.targetColumn=this.viewModel.parameters.targetColumn;
    //   })
    // }
  }
  onParameterFormStatusChange(status: boolean) {
    this.isParameterFormValid = status;
  }

  CalculateFieldsMapped(){
    var options: string[] = [];
    this.viewModel.mapTable.filter(field=>field.mapInclude==true).forEach(map=>{
      options.push(map.mapTo);
    });
    // Get unique values
    var options = Array.from(new Set(options)).sort();
    this.viewModel.sortInfoOutColumns=options.map( i => new OptionItem(i, i));
    if(!this.viewModel.sequenceL2){
      this.viewModel.sortInfoOutColumns=this.viewModel.sortInfoOutColumns.filter((x) => !['taskOrder', 'isOpenTask', 'isCloseTask'].includes(x.text));
    }
    console.log("CalculateFieldsMapped :",this.viewModel.sortInfoOutColumns);
  }
  removeInvalidSortFields(){
    const validSortFields = this.viewModel.sortInfoOutColumns.map(item => item.text);
    // Filter out any sortInfo where the sortField is not present in the sourceColumns' values
    if(this.viewModel.sortInfoOut){
      console.log("this.viewModel.sortInfoOut :",this.viewModel.sortInfoOut);
      this.viewModel.sortInfoOut = this.viewModel.sortInfoOut.filter(sortItem => validSortFields.includes(sortItem.sortField));
    }
  }
  removeInvalidAcrossFields(){
    const validAcrossFields = this.viewModel.parameters.sourceColumns.map(item => item.text);
    console.log("validAcrossFields",validAcrossFields);
    // Filter out any sortInfo where the sortField is not present in the sourceColumns' values
    // this.viewModel.rules.filter(r=>r.fieldList[0].text!="All Fields").forEach(rule=>{
    //   console.log("rule.fieldList",rule.fieldList);
    //   rule.fieldList=rule.fieldList.filter(field => validAcrossFields.includes(field.text));
    // });
  }
  disabledMapToFields:any
  // onChangeMapTo(nodeID:string,map:JoinerMapper){
  //   var maps=this.viewModel.fieldMap.find(x=>x.nodeID==nodeID).mapTable.filter(f=>f.mapTo==map.mapTo && f.mapTo!='None');
  //   if (maps.length>1) {
  //     this.displayWarning("Duplicate value is not allowed.","Duplicate field found");
  //     map.mapTo = 'None'; // Reset field value
  //   }
  //   this.CalculateFieldsMapped();
  //   //remove field from sort parameter
  //   this.removeInvalidSortFields(); 
  //   this.removeInvalidAcrossFields(); 
  // }
  // Method to determine if an option should be disabled
  // isOptionDisabled(nodeID:string,item: string): boolean {
  //   //console.log(nodeID,item)
  //   this.disabledMapToFields = new Set(this.viewModel.fieldMap.find(x=>x.nodeID==nodeID).mapTable.map(f => f.mapTo));
  //   //console.log('isOptionDisabled value: ', this.disabledMapToFields );
  //   return this.disabledMapToFields.has(item);
  // }
  DataWriter(){
    if(this.cacheStatus=="Cached"){
      this.isDisabledDW=false;
      this.exportComponent.initializeExportComponent();
    }else{
      this.isDisabledDW=true;
      this.snackBar.open(`The Transformer is not cached`, 'Dismiss', {
        duration: 5000
      });
    }
  }
  onToggleInclude(rule: FarmConverterRule){
    // console.log("rule :",rule);
    // console.log("rule.mapInclude :",rule.mapInclude);
    if(!rule.mapInclude){
      rule.mapShow=false;
    }
    this.CalculateFieldsMapped();
    this.removeInvalidSortFields();
  }
  onToggleSequenceL2(){
    this.mapTableBySequenceL2();
    this.CalculateFieldsMapped();
    this.removeInvalidSortFields();
    this.cdRef.detectChanges();
  }
  async mapTableBySequenceL2(): Promise<void>{
    console.log("mapTableBySequenceL2 :");
    if(this.viewModel.sequenceL2){
      this.dataSource.data=this.viewModel.mapTable;
    }else{
      this.dataSource.data=this.viewModel.mapTable.filter((x) => !['taskOrder', 'isOpenTask', 'isCloseTask'].includes(x.mapTo));
    }
    console.log("this.viewModel.mapTable :",JSON.stringify(this.viewModel.mapTable));
  }
  
  onMapToChange(rule: any) {
    if (rule.mapTo === '') {
        rule.mapTo =undefined;
        rule.mapInclude = false;
    }
  }
  isShowDropdownMapType(rule: FarmConverterRule):boolean{
    var node=this.userData.getSelectedNodeDetails();
    if(node.farmtypeid==DataFarmType.task){
      if(rule.mapFrom=="activityName" || rule.mapFrom=="activityJid" || rule.mapFrom=="caseUid"){
        return true;
      }
    }
    else if(node.farmtypeid==DataFarmType.activity){
      if(rule.mapFrom=="caseUid"){
        return true;
      }
    }
    return false;
  }
  get hasRequiredFieldError(): boolean {
    // console.log("hasRequiredFieldError :",this.form.invalid && this.form.touched && this.form.hasError('required'));
    // console.log("this.form.invalid :",this.form.invalid);
    // console.log("this.form.touched :",this.form.touched);
    // console.log("this.form.hasError('required') :",this.form.hasError('required'));
    return this.form.invalid;
  }
  get isValidateParameters(): boolean {
    return !(this.isParameterFormValid && this.formparam.valid);
  }
  get isValidateAdvanceSettings(): boolean {
    return this.form.invalid;
  }

  onTabClick(event: MatTabChangeEvent): void {
    const selectedTabIndex = event.index;
    const selectedTabLabel = event.tab.textLabel;
    this.selectedIndex = selectedTabIndex;
 
    // Alert the tab index and label
   // alert(`Tab clicked: ${selectedTabLabel} (Index: ${selectedTabIndex})`);
    this.userData.setResultsTabClicked(false); 
    if(selectedTabLabel.match("Input") && selectedTabIndex == 0) {
      this.userData.setInputTabClicked(true);
    } else {
      this.userData.setInputTabClicked(false);
      // if(selectedTabLabel.match("Summary") && selectedTabIndex == 2) {
      //   if(this.source.length > 0) {
      //     let selectFilterInfoSummary = new SelectFilterInfo(this.source, this.selectFilterValues);
      //     this.onApplySelect(selectFilterInfoSummary);
      //   }
      // }
    }
  }

  setFarmConverterPreviewTabClicked(): void {
    if(this.selectedIndex == 0) {
      this.userData.setInputTabClicked(true);
    } else {
      this.userData.setInputTabClicked(false);
    }
  }
  onToggleResetRows(event: any){
    this.viewModel.resetRows=event.checked;
  }
  getFieldType(field:string):string{
    return "";
  }
  onUserSelectionChange(field:string):void{
    this.viewModel.mapTable.filter(mf=>mf.isDefault==true).forEach(map=>{
      if(this.userKeywords.some(k => map.mapFrom.includes(k))){
        map.mapFrom=field;
      }
      if(this.userKeywords.some(k => map.mapTo.includes(k))){
        map.mapTo=field;
      }
    });
    this.settingMapTable();
    this.viewModel.mapTable=[...this.viewModel.mapTable];
  }
  onTimeStampSelectionChange(field:string):void{
    if(this.farmtypeid==DataFarmType.task){
      this.viewModel.mapTable.filter(mf=>mf.isDefault==true).forEach(map=>{
        if(this.dateTimeKeywords.some(k => map.mapFrom.includes(k))){
          map.mapFrom=field;
        }
      });
      this.settingMapTable();
      this.viewModel.mapTable=[...this.viewModel.mapTable];
    }
  }
  async settingMapTable(): Promise<void>{
    var node=this.userData.getSelectedNodeDetails();
    if(node.farmtypeid==DataFarmType.task){
      this.configs = await this.configService.getFarmMappingConfigs(DataFarmType.task);
    }
    else if(node.farmtypeid==DataFarmType.activity){
      this.configs =await this.configService.getFarmMappingConfigs(DataFarmType.activity);
    }

    var storejsonmapTable=[...this.viewModel.mapTable];
    this.viewModel.mapTable=[];//clear
    //if(this.viewModel.mapTable.length==0){
      this.viewModel.targetColumns=[];
      if(node.farmtypeid==DataFarmType.task){
        var dataDictionaryItems = this.dataDictService.getColumns(DataDictionaryType.task);
        this.viewModel.targetColumns=dataDictionaryItems.map( i => i.Field).sort();
        //this.configs = await this.configService.getFarmMappingConfigs(2);
        
        this.configs.forEach(map=>{
          if(this.userKeywords.some(k => map.mapFrom.includes(k))){
            // var storejason=storejsonmapTable.filter(ms=>ms.isDefault==true).find(mt=>this.userKeywords.some(k => mt.mapFrom.includes(k)));
            // if(storejason){
            //   map.mapFrom=storejason.mapFrom;
            //   map.mapTo=storejason.mapTo;
            // }
            map.mapFrom=this.viewModel.userField;
            map.mapTo=this.viewModel.userField;
          }else if(this.dateTimeKeywords.some(k => map.mapFrom.includes(k))){
            //if(this.farmtypeid==DataFarmType.task){
              // var storejason=storejsonmapTable.filter(ms=>ms.isDefault==true).find(mt=>this.dateTimeKeywords.some(k => mt.mapFrom.includes(k)));
              // if(storejason){
              //   map.mapFrom=storejason.mapFrom;
              //   map.mapTo=storejason.mapTo;
              // }
            //}
            map.mapFrom=this.viewModel.timestampField;
            //map.mapTo=this.viewModel.timestampField;
          }
          // const id = this.viewModel.mapTable.length;
          // map.mapIndex = id;
          map.isDefault=true;

          const vm = new FarmConverterRuleViewModel(map);
          this.viewModel.mapTable.push(vm);
          this.isRuleSetEmpty = false;
        });

        //optionalcolumns
        var optionalcolumns=this.viewModel.sourceColumns.filter(x=>!this.configs.some(i=>i.mapFrom===x.text));
        optionalcolumns.forEach(opt=>{
          var map=new FarmConverterRule();
          map.mapIndex = this.viewModel.mapTable.length;
          map.mapInclude = false;
          map.mapFrom = opt.text;
          map.mapType = MapControlLegendType.fcoptionone;
          var tfield=this.viewModel.targetColumns.find(m=>m==opt.text);
          if(tfield!=null){
            map.mapTo =opt.text;
            map.mapInclude = true;
          }
          else{
            map.mapTo = "";
          }
          map.mapShow = false;
          map.isDefault = false;
          //default include=true
          if(opt.text=="activityName" || opt.text=="activityJid" || opt.text=="caseUid"){
            map.mapInclude = true;
          }
          const vm = new FarmConverterRuleViewModel(map,);
          this.viewModel.mapTable.push(vm);
          this.isRuleSetEmpty = false;
        });
        //this.dataSource.data = this.viewModel.mapTable;

         this.viewModel.sequenceL2=true;
      }
      else if(node.farmtypeid==DataFarmType.activity){
        var dataDictionaryItems = this.dataDictService.getColumns(DataDictionaryType.activity);
        this.viewModel.targetColumns=dataDictionaryItems.map( i => i.Field).sort();

        this.configs.forEach(map=>{
          if(this.userKeywords.some(k => map.mapFrom.includes(k))){
            // var storejason=storejsonmapTable.filter(ms=>ms.isDefault==true).find(mt=>this.userKeywords.some(k => mt.mapFrom.includes(k)));
            // if(storejason){
            //   map.mapFrom=storejason.mapFrom;
            //   map.mapTo=storejason.mapTo;
            // }
            map.mapFrom=this.viewModel.userField;
            map.mapTo=this.viewModel.userField;
          }
          // else if(this.dateTimeKeywords.some(k => map.mapFrom.includes(k))){
          //   if(this.farmtypeid==DataFarmType.task){
          //     // var storejason=storejsonmapTable.filter(ms=>ms.isDefault==true).find(mt=>this.dateTimeKeywords.some(k => mt.mapFrom.includes(k)));
          //     // if(storejason){
          //     //   map.mapFrom=storejason.mapFrom;
          //     //   map.mapTo=storejason.mapTo;
          //     // }
          //     map.mapFrom=this.viewModel.timestampField;
          //     map.mapTo=this.viewModel.timestampField;
          //   }
          // }
          map.isDefault=true;
          const vm = new FarmConverterRuleViewModel(map);
          this.viewModel.mapTable.push(vm);
          this.isRuleSetEmpty = false;
        });

        //optionalcolumns
        var optionalcolumns = this.viewModel.sourceColumns.filter(x=>!this.configs.some(i=>i.mapFrom===x.text));
        optionalcolumns.forEach(opt=>{
          var map=new FarmConverterRule();
          map.mapIndex = this.viewModel.mapTable.length;
          map.mapInclude = false;
          map.mapFrom = opt.text;
          map.mapType = MapControlLegendType.fcoptionone;
          var tfield=this.viewModel.targetColumns.find(m=>m==opt.text);
          if(tfield!=null){
            map.mapTo =opt.text;
            map.mapInclude = true;
          }
          else{
            map.mapTo = "";
          }
          map.mapShow = false;
          map.isDefault = false;
          //default include=true
          if(opt.text=="caseUid"){
            map.mapInclude = true;
          }
          const vm = new FarmConverterRuleViewModel(map,);
          this.viewModel.mapTable.push(vm);
          this.isRuleSetEmpty = false;
        });
        //this.dataSource.data = this.viewModel.mapTable;

         this.viewModel.sequenceL2=false;
      }
    //}
    //check if ingest change anythings then remove
    //console.log("this.viewModel.mapTable : ",this.viewModel.mapTable);
    // this.viewModel.mapTable=this.viewModel.mapTable.filter(mapper=>
    // (mapper.isDefault==true) ||
    //   (mapper.isDefault==false && this.viewModel.sourceColumns.some(i=>i.text===mapper.mapTo)));
    //again set value
    this.viewModel.mapTable.filter(mt=>mt.isDefault==false).forEach(map=>{
      var storejason=storejsonmapTable.find(mt=>mt.mapFrom==map.mapFrom);
      if(storejason){
        //map.mapFrom=storejason.mapFrom;
        map.mapType=storejason.mapType;
        map.mapTo=storejason.mapTo;
        map.mapInclude=storejason.mapInclude;
        map.mapShow=storejason.mapShow;
      }else{
        //if(node.farmtypeid==2){
          //if(map.mapFrom=="activityName" || map.mapFrom=="activityJid" || map.mapFrom=="caseUid"){
          if(map.mapFrom!=map.mapTo){
            map.mapTo = undefined;
          }
        //}
        //else if(node.farmtypeid==3){
         // if(map.mapFrom!=map.mapTo){
            //map.mapTo = undefined;
          //}
        //}
      }
    });
    //for default
    // this.viewModel.mapTable.filter(mt=>mt.isDefault==true).forEach(map=>{
    //   if(this.userKeywords.some(k => map.mapFrom.includes(k))){
    //     var storejason=storejsonmapTable.filter(ms=>ms.isDefault==true).find(mt=>this.userKeywords.some(k => mt.mapFrom.includes(k)));
    //     if(storejason){
    //       map.mapFrom=storejason.mapFrom;
    //       map.mapTo=storejason.mapTo;
    //     }
    //   }else if(this.dateTimeKeywords.some(k => map.mapFrom.includes(k))){
    //     if(this.farmtypeid==DataFarmType.task){
    //       var storejason=storejsonmapTable.filter(ms=>ms.isDefault==true).find(mt=>this.dateTimeKeywords.some(k => mt.mapFrom.includes(k)));
    //       if(storejason){
    //         map.mapFrom=storejason.mapFrom;
    //         map.mapTo=storejason.mapTo;
    //       }
    //     }
    //   }
    // });
    this.dataSource.data = this.viewModel.mapTable;
    //end
    // Check mandatory fields are present or not in input
    //const diff = this.viewModel.sourceColumns.filter(x=>!this.configs.some(i=>i.mapFrom===x.text));
    this.compulsorydiff = this.configs.filter(x=>!this.viewModel.sourceColumns.some(i=>i.text===x.mapFrom));
    //update rule table height
    if(this.viewModel.mapTable.length<=12){
      this.minrowcount=this.viewModel.mapTable.length;
    }else{
      this.minrowcount=12;
    }
    this.maxrowcount=this.viewModel.mapTable.length;
  }

  onTargetColumnChanged(value: ColumnMapDefinitionModel, event: any): void {
    this.getDisabledColumns();
  }
  handleMoveToField(direction: 'forward' | 'reverse', index: number) {
    if (direction  === 'reverse') {
      this.focusPreviousInput(index);
    } else {
      this.focusNextInput(index);
    }
  }
  focusNextInput(index: number) {
    const inputElements = Array.from(document.querySelectorAll('app-autocomplete-field input')) as HTMLInputElement[];
    const currentIndex = inputElements.findIndex(el => el.tabIndex === index);
    if (currentIndex !== -1 && currentIndex + 1 < inputElements.length) {
      const nextInput = inputElements[currentIndex + 1];
      nextInput.focus();
    }
  }
  focusPreviousInput(index: number) {
    const inputElements = Array.from(document.querySelectorAll('app-autocomplete-field input')) as HTMLInputElement[];
    const currentIndex = inputElements.findIndex(el => el.tabIndex === index);
    if (currentIndex !== -1 && currentIndex - 1 < inputElements.length) {
      const preInput = inputElements[currentIndex - 1];
      preInput.focus();
    }
  }
  getDisabledColumns(){
    this.disabledColumns = this.viewModel.mapTable.map(item => item.mapTo);
  }
  async onRunTransformValidate() {
    if (this.isRequiredFieldMissing) {
      this.displayError('Cannot run the converter, please correct errors (red font) below.','Validation Error','');
      return;
    }
    else{
      this.onRunTransform();
    }
  }
  async setDefaultValues(transformType:TransformType): Promise<void>{
    const selectedNode=this.userData.getSelectedNodeDetails();
    const masterconfig=this.userData.getMasterTransformers().find(x=>x.id==transformType);
    var parameters=masterconfig.parameters.find(x=>x.farmtypeid==selectedNode.farmtypeid);
    if(parameters){
      var params=parameters.parameters;
      this.resetRows=params.find(x=>x.jsonobject=='resetRows');
      //other parameters
      this.sortInfoa=params.find(x=>x.jsonobject=='sortInfo');
      this.sortInfoOut=params.find(x=>x.jsonobject=='sortInfoOut');
      //advanced settings parameters
      this.timestampFielda=params.find(x=>x.jsonobject=='timestampFielda');
      this.groupBy=params.find(x=>x.jsonobject=='groupBy');
      this.groupByL2=params.find(x=>x.jsonobject=='groupByL2');
      this.defSourceFielda=params.find(x=>x.jsonobject=='defSourceFielda');
      this.entityList=params.find(x=>x.jsonobject=='entityList');
      this.userField=params.find(x=>x.jsonobject=='userField');
      this.bufferRows=params.find(x=>x.jsonobject=='bufferRows');
      this.threads=params.find(x=>x.jsonobject=='threads');
      this.listSeparator=params.find(x=>x.jsonobject=='listSeparator');
      this.defTimeout=params.find(x=>x.jsonobject=='defTimeout');
      this.sequenceL2=params.find(x=>x.jsonobject=='sequenceL2');
      //check this is first this.viewModel.sampleEnd =0
      if((this.viewModel.sampleEnd-1)==0 || isNaN(this.viewModel.sampleEnd)){
        if(this.resetRows.default!=""){
          this.viewModel.resetRows=this.stringToBoolean(this.resetRows.default);
        }
        // //other parameters
        var sorts=JSON.parse(this.sortInfoa.default.replace(/'/g, '"'));
        this.viewModel.sortInfo=sorts.map((item: any) => {
              return {
                  sortField: item.sortField,
                  sortAscending: item.sortAscending
              };
          });
          console.log("this.viewModel.sortInfo1 :",this.viewModel.sortInfo);
          //other parameters Filter invalid sort fields
          const baseField = this.viewModel.sortInfo[this.viewModel.sortInfo.length - 1]?.sortField;
          this.viewModel.sortInfo = this.viewModel.sortInfo.filter(sort => {
            return this.viewModel.sourceColumns.some(sc => sc.value === sort.sortField);
          });
          //Generate choices
          const choices: string[] = [];
          const sortFields = this.viewModel.sortInfo.filter(si=>si.sortField!=baseField);
          if(sortFields.length>1){
            this.removeSortInfo(this.viewModel.sortInfo[1]);
          }

        var sorts=JSON.parse(this.sortInfoOut.default.replace(/'/g, '"'));
        this.viewModel.sortInfoOut=sorts.map((item: any) => {
              return {
                  sortField: item.sortField,
                  sortAscending: item.sortAscending
              };
          });
        console.log("this.viewModel.sortInfo2 :",this.viewModel.sortInfo);
        //advanced settings parameters
        // for(let pr of this.timestampFielda.default.split(";")){
        //   const foundColumn = this.viewModel.sourceColumns.find(sc => sc.value == pr);
        //   if(foundColumn){
        //     this.viewModel.timestampField=foundColumn.value;
        //     break;
        //   }
        // }
        // for(let pr of this.groupBy.default.split(";")){
        //   const foundColumn = this.viewModel.sourceColumns.find(sc => sc.value == pr);
        //   if(foundColumn){
        //     this.viewModel.groupBy=foundColumn.value;
        //     break;
        //   }
        // }
        // for(let pr of this.groupByL2.default.split(";")){
        //   const foundColumn = this.viewModel.sourceColumns.find(sc => sc.value == pr);
        //   if(foundColumn){
        //     this.viewModel.groupByL2=foundColumn.value;
        //     break;
        //   }
        // }
        // for(let pr of this.defSourceFielda.default.split(";")){
        //   const foundColumn = this.viewModel.sourceColumns.find(sc => sc.value == pr);
        //   if(foundColumn){
        //     this.viewModel.defSourceField=foundColumn.value;
        //     break;
        //   }
        // }
        // for(let pr of this.userField.default.split(";")){
        //   const foundColumn = this.viewModel.sourceColumns.find(sc => sc.value == pr);
        //   if(foundColumn){
        //     this.viewModel.userField=foundColumn.value;
        //     break;
        //   }
        // }
        if(this.bufferRows.default!=""){
          this.viewModel.bufferRows=Number(this.bufferRows.default);
        }
        if(this.threads.default!=""){
          this.viewModel.threads=Number(this.threads.default);
        }
        if(this.listSeparator.default!=""){
          this.viewModel.listSeparator=this.listSeparator.default;
        }
        if(this.defTimeout.default!=""){
          this.viewModel.defTimeout=Number(this.defTimeout.default);
        }
      }
    }else{
      //advanced settings parameters
      // this.bufferRows.label="Buffer Rows";this.bufferRows.jsonobject="bufferRows";this.bufferRows.min=0;this.bufferRows.max=10000000;
      // this.threads.label="Threads (0 > Auto)";this.threads.jsonobject="threads";this.threads.min=0;this.threads.max=64;
      // this.resetRows.label="Reset Row Numbers";this.resetRows.jsonobject="resetRows";
    }
  }
  async removeInvalidValues(): Promise<void>{
    //other parameters
    //advanced settings parameters
  }
  async loadImportTransformer(transform: any): Promise<void>{
      const busyIndicator = this.showBusyDialog('Please wait...');
      try{
        if(this.userData.getSelectedNodeDetails().farmtypeid!=transform.farmType){
          this.displayError("Current DataFarmType is " + DataFarmTypeUtil.toString(this.userData.getSelectedNodeDetails().farmtypeid) + ". But you are trying to load a different DataFarmType: " + DataFarmTypeUtil.toString(transform.farmType),"Error");
          return;
        }else if(this.transformType!=transform.transformType){
          this.displayError("Current transform is " + TransformTypeUtil.toString(this.transformType) + ". But you are trying to load a different transform type: " + TransformTypeUtil.toString(transform.transformType),"Error");
          return;
        }
        var ctranformconfig=this.dataTransformConfigViewModel.transforms.find(x=>x.guid=== this.userData.getSelectedTransform().guid);
        ctranformconfig.transform.transformConfig=transform;
        var newmodel =new FarmConverterTransformDetailViewModel(this.dataDictService,this.configService,this.dataTransformConfigViewModel,ctranformconfig);
        // force new object reference for UI refresh
        // this.viewModel.rules=[];
        // this.viewModel.rules=[...newmodel.rules];
        // this.isRuleSetEmpty = this.viewModel.rules.length === 0;
        // this.dataSource.data = this.viewModel.rules;
        // //update rule table height
        // if(this.viewModel.rules.length<=10){
        //   this.minrowcount=this.viewModel.rules.length;
        // }else{
        //   this.minrowcount=10;
        // }
        // this.maxrowcount=this.viewModel.rules.length;
      }catch (err) {
        this.displayError(`Failed to save import transformer`, 'Error', err);
      }finally {
        busyIndicator.close();
      }
    }
}
